'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loadScript = require('./loadScript');

var _loadScript2 = _interopRequireDefault(_loadScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _loadScript2.default;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/video-asset/~/@spp/script-loader/lib/cjs/index.js
 ** module id = 710
 ** module chunks = 1
 **/